import { isPlatformBrowser } from '@angular/common';
import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewEncapsulation} from '@angular/core';

declare var window: any;
@Component({
    selector: 'covid-map',
    template: `
        <div class="covid-map-container">
            <smt-swidget
                manlaunch="true"
                apikey="29ea3621-26bc-4791-99bb-de54239dcc79"
                [lang]="lang"
                class="smt-swidget"
                withdisclaimer="enabled">
            </smt-swidget>
        </div>
    `,
    styleUrls: ['./covid-map.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CovidMapComponent implements OnInit {
    @Input() lang: string
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onLoad = new EventEmitter()

    constructor(@Inject(PLATFORM_ID) private platformId: string) {}

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.insertScript();
            document.addEventListener('SMTEngageSSMTW', this.initializeWidget, true)
        }
    }

    initializeWidget = () => {
        setTimeout(() => {
            if (window['SmtSWidget'] && window['SmtBootSWidget']) {
                window['SmtBootSWidget'].ignite()
            }
            this.onLoad.emit()
        }, 0)
    }

    insertScript = () => {
        if (window && !window['SmtBootSWidget']) {
            const prod = 'https://cdn.smartvel.com/scripts/swidget/boot.min.js';
            let $script = document.createElement('script');
            $script.src = prod;
            document.body.appendChild($script);
        }
    }

}
